import { request, success, failure, ZOOM } from "./utilities";
import {
  getAllZoomMeeting,
  meetingSingleRecord,
  zoomInstantMeeting,
  zoomOAuthMeeting,
  zoomScheduleMeeting,
  zoomUpdateScheduleMeeting,
} from "../api";

export function getAllZoomMeetingAction(data) {
  return (dispatch) => {
    dispatch(request(ZOOM.GET_ALL_MEETINGS_REQUEST));
    getAllZoomMeeting(data).then(
      (response) => {
        if (response.data.Succeeded) {
          dispatch(success(ZOOM.GET_ALL_MEETINGS_SUCCESS, response.data.data));
        } else {
          dispatch(
            failure(ZOOM.GET_ALL_MEETINGS_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ZOOM.GET_ALL_MEETINGS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function createInstantMeetingAction(clientData, moveToNext) {
  return (dispatch) => {
    dispatch(request(ZOOM.CREATE_INSTANT_MEETING_REQUEST));
    zoomInstantMeeting(clientData).then(
      (response) => {
        if (response.data.Succeeded) {
          dispatch(
            success(ZOOM.CREATE_INSTANT_MEETING_SUCCESS, response.data.data)
          );
          moveToNext(response);
        } else {
          dispatch(
            failure(ZOOM.CREATE_INSTANT_MEETING_FAILURE, response.data.message)
          );
          moveToNext(response);
        }
      },
      (error) => {
        dispatch(
          failure(
            ZOOM.CREATE_INSTANT_MEETING_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
        moveToNext();
      }
    );
  };
}

export function createScheduleMeeting(clientData, moveToNext) {
  return (dispatch) => {
    dispatch(request(ZOOM.CREATE_SCHEDULE_MEETING_REQUEST));

    zoomScheduleMeeting(clientData).then(
      (response) => {
        if (response.data.Succeeded || response.data.message === "Success") {
          dispatch(
            success(ZOOM.CREATE_SCHEDULE_MEETING_SUCCESS, response.data.data)
          );
          if (moveToNext) {
            moveToNext(response);
          }
        } else {
          dispatch(
            failure(ZOOM.CREATE_SCHEDULE_MEETING_FAILURE, response.data.message)
          );
          if (moveToNext) {
            moveToNext(response);
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            ZOOM.CREATE_SCHEDULE_MEETING_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function updateScheduleMeeting(id, data, moveToNext) {
  return (dispatch) => {
    dispatch(request(ZOOM.UPDATE_SCHEDULE_MEETING_REQUEST));
    zoomUpdateScheduleMeeting(id, data).then(
      (response) => {
        if (response.data.Succeeded || response.data.message === "Success") {
          dispatch(
            success(ZOOM.UPDATE_SCHEDULE_MEETING_SUCCESS, response.data.data)
          );
          if (moveToNext) {
            moveToNext(response);
          }
        } else {
          dispatch(
            failure(ZOOM.UPDATE_SCHEDULE_MEETING_FAILURE, response.data.message)
          );
          if (moveToNext) {
            moveToNext(response);
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            ZOOM.UPDATE_SCHEDULE_MEETING_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

// export function zoomOAuth(data) {
//   return (dispatch) => {
//     dispatch(request(ZOOM.ZOOM_OAUTH_REQUEST));
//     zoomOAuthMeeting(data).then(
//       (response) => {
//         if (response.data.Succeeded || response.data.message === "Success") {
//           dispatch(success(ZOOM.ZOOM_OAUTH_SUCCESS, response.data.data));
//         } else {
//           dispatch(failure(ZOOM.ZOOM_OAUTH_FAILURE, response.data.message));
//         }
//       },
//       (error) => {
//         dispatch(
//           failure(
//             ZOOM.ZOOM_OAUTH_FAILURE,
//             error &&
//               error.response &&
//               error.response.data &&
//               error.response.data.title
//               ? error.response.data.title
//               : error.message
//           )
//         );
//       }
//     );
//   };
// }

export function getMeetingRecord(meetingId, email, showEditMeetingModal) {
  return (dispatch) => {
    dispatch(request(ZOOM.GET_SINGLE_MEETING_REQUEST));
    meetingSingleRecord(meetingId, email).then(
      (response) => {
        if (response.data.Succeeded || response.data.message === "Success") {
          dispatch(
            success(ZOOM.GET_SINGLE_MEETING_SUCCESS, response.data.data)
          );
          if (showEditMeetingModal) showEditMeetingModal(response);
        } else {
          dispatch(
            failure(ZOOM.GET_SINGLE_MEETING_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ZOOM.GET_SINGLE_MEETING_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
